import axios from '@/axios.js'

export default ({
  isRegistered: false,
  namespaced: true,
  state: {
    anuncios: []
  },
  actions: {
    addDocumentos (context, formData) {      
      return new Promise((resolve, reject) => {
        axios.post('/api/anuncios', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
          .then((response) => {
            resolve(response)
          })
          .catch((error) => { 
            reject(error) 
          })
      })
    },
    deleteDocumento (context, id) {
      return new Promise((resolve, reject) => {
        axios.delete(`/api/anuncios/${id}`)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => { 
            reject(error) 
          })
      })
    },
    getDocumentos ({commit}) {
      return new Promise((resolve, reject) => {
        axios.get('/api/anuncios')
          .then((response) => {
            commit('setAnunciosActivosMutation', response.data['hydra:member'])
            resolve(response.data['hydra:member'])
          })
          .catch((error) => { 
            reject(error) 
          })
      })
    },
    deleteDocumentos ({commit}, id) {
      return new Promise((resolve, reject) => {
        axios.delete(`/api/anuncios/${id}`)
          .then((response) => {
            commit('deleteAnunciosMutation', id) 
            resolve(response)           
          })
          .catch((error) => {  
            reject(error)
          })
      })
    }
  },
  mutations: {
    setAnunciosActivosMutation (state, anuncio) {
      state.anuncios = anuncio
    },
    deleteAnunciosMutation (state, id) {
      const idx = state.anuncios.findIndex((u) => u.id === id)
      state.anuncios.splice(idx, 1)
    }
  },
  modules: {}
})